
export class ActualizacionPrecioAdd {

  static codInterna = 'VIACOTONE';

  description: string;
  etiquetaModificacionPrecio:string;
  aumentoPrecio: number;
  fechaDesde: string;
  fechaHasta: string;
  proveedorId: number;
  promocion:boolean = false;
  
}



// WEBPACK FOOTER //
// ./src/app/productos/modificacion-precio/actualizacion-precio-add.model.ts